//  This code loads the IFrame Player API code asynchronously.
var tag = document.createElement( 'script' );
var VIDEO_INITIALISATORS = VIDEO_INITIALISATORS || [];

tag.src            = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName( 'script' )[0];
firstScriptTag.parentNode.insertBefore( tag, firstScriptTag );

// Gets t
var player;

// This function creates an <iframe> (and YouTube player)
// after the API code downloads.
// https://developers.google.com/youtube/player_parameters
var videoPlayer                = document.getElementById( "player" );
VIDEO_INITIALISATORS.push(function() {
	if (null !== videoPlayer) {
		player = new YT.Player(
			"player", {
				height: "100%",
				width: "100%",
				videoId: videoPlayer.dataset.videoId,
				playerVars: {
					showinfo: "0",
					modestbranding: "1",
					color: "white",
					iv_load_policy: "3",
					rel: "0"
				}
			}
		);
	}
}
						 )
function onYouTubeIframeAPIReady() {
	VIDEO_INITIALISATORS.forEach(function(e){
		e();
	})
}

